/* PAKKS PRODUCT PAGES (theme): behaviour for the pk-pdp-* / pk-video-row sections. Vanilla, no libraries. Port of the approved
   preview's site/products/pdp.js. The Liquid HTML is complete without this file (the Add to cart form posts to /cart/add);
   this adds:
   1. gallery: thumbnails (aria-current), Previous/Next, arrow keys on thumbnails, swipe on the image. No autoplay.
   2. flip-card stacks, scroll rows (Previous/Next, track focusable only while it scrolls), carousels (piece + compare cards)
   3. What's inside disclosure, "Read all reviews" jump (moves focus), Mini deck chooser (variant), US arrival estimate
   4. deck pages: "Build your box" (the 2 / 3 / 5 cards open a slide-up picker; figures pre-rendered by Liquid per market)
   5. Add to cart: window.PakksCart.add(lines, {open: true}) when the cart drawer is present; otherwise POST /cart/add.js,
      dispatch 'pk:cart:updated' (+ 'pk:cart-updated' for the header count) and click [data-pk-cart-toggle].
   6. sticky bar (phones), shown after the main button scrolls away, hidden while the footer is on screen
   7. customer videos: native <dialog> player (focus stays inside, Esc closes, focus returns), one video plays at a time
   Motion: smooth scrolling and transitions are dropped under prefers-reduced-motion. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pk-pdp]');
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PK = window.PAKKS || {};
  var $ = function (sel, scope) { return (scope || document).querySelector(sel); };
  var $$ = function (sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); };
  var live = $('[data-live]');
  function say(t) { if (!live) return; live.textContent = ''; setTimeout(function () { live.textContent = t; }, 60); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function fillT(t, o) { return String(t).replace(/\{(\w+)\}/g, function (m0, k) { return k in o ? o[k] : m0; }); }
  function json(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* ================= 1. gallery ================= */
  function initGallery() {
    var g = $('[data-gallery]'); if (!g) return;
    var slides = $$('[data-slide]', g), thumbs = $$('[data-thumb]', g), n = slides.length, cur = 0;
    if (n < 2) return;
    function show(i, focusThumb) {
      i = (i + n) % n;
      slides.forEach(function (s, k) { s.hidden = k !== i; s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      cur = i;
      var row = thumbs[i] && thumbs[i].closest('.pdp-thumbs'), li = thumbs[i] && thumbs[i].parentNode;
      // keep the active thumb inside the row's gutter (scroll-padding), never flush against the clipped edge
      if (row && li) {
        var pad = parseFloat(getComputedStyle(row).scrollPaddingLeft) || 0, x = li.offsetLeft - row.offsetLeft * (li.offsetParent === row ? 0 : 1);
        if (x - pad < row.scrollLeft || x + li.offsetWidth + pad > row.scrollLeft + row.clientWidth) row.scrollTo({ left: Math.max(0, x - pad), behavior: RM ? 'auto' : 'smooth' });
      }
      if (focusThumb) thumbs[i].focus();
    }
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { show(k); });
      t.addEventListener('keydown', function (e) {
        var to = { ArrowRight: k + 1, ArrowDown: k + 1, ArrowLeft: k - 1, ArrowUp: k - 1, Home: 0, End: n - 1 }[e.key];
        if (to === undefined) return;
        e.preventDefault(); show(to, true);
      });
    });
    var pv = $('[data-gal-prev]', g), nx = $('[data-gal-next]', g);
    if (pv) pv.addEventListener('click', function () { show(cur - 1); });
    if (nx) nx.addEventListener('click', function () { show(cur + 1); });
    var stage = $('.pdp-gallery__stage', g), sx = null, sy = 0;
    if (stage) {
      stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') return; sx = e.clientX; sy = e.clientY; });
      stage.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1)); });
      stage.addEventListener('pointercancel', function () { sx = null; });
    }
  }

  /* ================= 2a. flip-card stacks ================= */
  function initSamples(scope) {
    $$('[data-samples]', scope).forEach(function (w) {
      if (w.__init) return; w.__init = true;
      var cards = $$('.rx-qcard', w), cnt = $('.rx-samples__count', w), tpl = cnt.getAttribute('data-count-tpl'), i = 0, n = cards.length;
      $('.rx-samples__next', w).addEventListener('click', function () {
        cards[i].classList.remove('is-on'); cards[i].setAttribute('aria-hidden', 'true');
        i = (i + 1) % n;
        cards[i].classList.add('is-on'); cards[i].removeAttribute('aria-hidden');
        cnt.textContent = tpl.replace('{i}', i + 1).replace('{n}', n);
      });
    });
  }

  /* ================= 2b. scroll rows ================= */
  function initRow(scope) {
    $$('[data-row]', scope).forEach(function (row) {
      var track = $('[data-row-track]', row); if (!track || track.__init) return; track.__init = true;
      var list = track.firstElementChild, prev = $('[data-row-prev]', row), next = $('[data-row-next]', row);
      function stepW() { var c = list.children; return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : track.clientWidth; }
      function sync() {
        var scrollable = track.scrollWidth > track.clientWidth + 2;
        if (scrollable) track.setAttribute('tabindex', '0'); else track.removeAttribute('tabindex');
        row.classList.toggle('is-scrollable', scrollable);
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
        if (next) next.setAttribute('aria-disabled', track.scrollLeft >= max ? 'true' : 'false');
      }
      function go(dir) { track.scrollBy({ left: dir * stepW(), behavior: RM ? 'auto' : 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      addEventListener('resize', sync, { passive: true });
      requestAnimationFrame(sync);
    });
  }

  /* ================= 2c. carousels (piece panels, compare cards) ================= */
  function initCarousel(scope) {
    $$('[data-carousel]', scope).forEach(function (car) {
      if (car.__init) { car.__refresh(); return; }
      car.__init = true;
      var track = $('[data-car-track]', car), dotsWrap = $('[data-car-dots]', car), cur = Math.max(0, +car.getAttribute('data-car-start') || 0), slides = [];
      var tplOf = car.getAttribute('data-slide-of') || '{i} of {n}', tplGo = car.getAttribute('data-go-to') || 'Go to slide {i}: {name}';
      var INSET = 16;
      function visible() { return $$('[data-car-slide]', car).filter(function (x) { return !x.hidden; }); }
      function startAlign() { return car.hasAttribute('data-car-start-mobile') && track.clientWidth < 768; }
      function pad() {
        var list = track.firstElementChild, sl = slides[0]; if (!sl || !sl.offsetWidth) return;
        if (startAlign()) { list.style.paddingLeft = INSET + 'px'; list.style.paddingRight = Math.max(INSET, track.clientWidth - sl.offsetWidth - INSET) + 'px'; }
        else { var p = Math.max(0, (track.clientWidth - sl.offsetWidth) / 2); list.style.paddingLeft = list.style.paddingRight = p + 'px'; }
      }
      function mark() {
        slides.forEach(function (sl, i) { sl.classList.toggle('is-active', i === cur); });
        $$('.pdp-car__dot', dotsWrap).forEach(function (d, i) { if (i === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
        var pv = $('[data-car-prev]', car), nx = $('[data-car-next]', car);
        pv.setAttribute('aria-disabled', cur <= 0 ? 'true' : 'false'); nx.setAttribute('aria-disabled', cur >= slides.length - 1 ? 'true' : 'false');
      }
      function go(i, instant) {
        i = Math.max(0, Math.min(slides.length - 1, i)); cur = i; mark();
        var sl = slides[i]; if (!sl) return;
        var left = startAlign() ? sl.offsetLeft - INSET : sl.offsetLeft - (track.clientWidth - sl.offsetWidth) / 2;
        track.scrollTo({ left: left, behavior: instant || RM ? 'auto' : 'smooth' });
      }
      function refresh() {
        slides = visible();
        dotsWrap.innerHTML = '';
        slides.forEach(function (sl, i) {
          var name = sl.getAttribute('data-slide-name');
          sl.setAttribute('aria-label', tplOf.replace('{i}', i + 1).replace('{n}', slides.length) + ': ' + name);
          var d = document.createElement('button'); d.type = 'button'; d.className = 'pdp-car__dot';
          d.setAttribute('aria-label', tplGo.replace('{i}', i + 1).replace('{name}', name));
          d.addEventListener('click', function () { go(i); });
          dotsWrap.appendChild(d);
        });
        pad();
        cur = Math.min(cur, slides.length - 1); mark(); go(cur, true);
      }
      $('[data-car-prev]', car).addEventListener('click', function () { go(cur - 1); });
      $('[data-car-next]', car).addEventListener('click', function () { go(cur + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.target !== track) return;
        var to = { ArrowRight: cur + 1, ArrowLeft: cur - 1, Home: 0, End: slides.length - 1 }[e.key];
        if (to === undefined) return;
        e.preventDefault(); go(to);
      });
      var t = 0;
      track.addEventListener('scroll', function () {
        clearTimeout(t); t = setTimeout(function () {
          var st = startAlign(), mid = st ? track.scrollLeft + INSET : track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
          slides.forEach(function (sl, i) { var c = st ? sl.offsetLeft : sl.offsetLeft + sl.offsetWidth / 2, dd = Math.abs(c - mid); if (dd < bd) { bd = dd; best = i; } });
          if (best !== cur) { cur = best; mark(); }
        }, 90);
      }, { passive: true });
      car.addEventListener('focusin', function (e) {
        var sl = e.target.closest('[data-car-slide]'); if (!sl) return;
        var i = slides.indexOf(sl); if (i >= 0 && i !== cur) go(i);
      });
      addEventListener('resize', function () { pad(); go(cur, true); }, { passive: true });
      car.__refresh = refresh;
      refresh();
    });
  }

  /* ================= 3. disclosure, jump, US arrival ================= */
  function initDisclosure(scope) {
    $$('[data-disclosure]', scope).forEach(function (b) {
      var panel = document.getElementById(b.getAttribute('aria-controls')); if (!panel) return;
      b.addEventListener('click', function () { var open = b.getAttribute('aria-expanded') !== 'true'; b.setAttribute('aria-expanded', open ? 'true' : 'false'); panel.hidden = !open; });
    });
  }
  function initJump(scope) {
    $$('a[data-jump]', scope).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
        // focus the target, or its focusable heading (e.g. #reviews -> "Hear from more couples")
        var f = t.matches('a[href], button, input, select, textarea, [tabindex]') ? t : (t.querySelector('h2[tabindex], h3[tabindex], [tabindex="-1"]') || t);
        if (f === t && !t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
        f.focus({ preventScroll: true });
        history.replaceState(null, '', a.getAttribute('href'));
      });
    });
  }
  function addBizDays(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
  function initArrives() {
    $$('[data-arrives]').forEach(function (ar) {
      var t = new Date(), a = addBizDays(t, 4), b = addBizDays(t, 8);
      var f = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
      var range = f.formatRange ? f.formatRange(a, b) : f.format(a) + '–' + f.format(b);
      ar.textContent = (ar.getAttribute('data-tpl') || 'Arrives {range}').replace('{range}', range);
      ar.hidden = false;
    });
  }

  /* ================= Mini: deck chooser (product variants) ================= */
  var DECKS = null;
  function applyDeck(k, radio) {
    var info = DECKS && DECKS[k];
    if (root) root.setAttribute('data-deck', k);
    $$('[data-deck]').forEach(function (n) { if (n.hasAttribute('data-pk-pdp')) return; n.hidden = n.getAttribute('data-deck') !== k; });
    $$('[data-carousel]').forEach(function (c) { if (c.__refresh) c.__refresh(); });
    var name = info ? info.name : (radio && radio.getAttribute('data-deck-name')) || '';
    var sd = $('[data-sticky-deck]'); if (sd && name) sd.textContent = ', ' + name;
    var vid = info ? info.variant : radio && radio.getAttribute('data-variant-id');
    $$('[data-pk-variant]').forEach(function (i) { i.value = vid; });
    // Kayci 24 Oct: the gallery never changes with the deck (image 1 stays the Studio's gallery image 1); the deck's box
    // photo shows only in its chooser card.
    var cta = document.getElementById('pdp-cta');
    if (cta && info) { if (info.available) cta.removeAttribute('aria-disabled'); else cta.setAttribute('aria-disabled', 'true'); }
  }
  // "Go Deeper Deck" / "The Go Deeper Deck" / "go-deeper" / "godeeper" -> "godeeper" (the deck_key)
  function deckNorm(s) { return String(s || '').toLowerCase().replace(/[^a-z]/g, '').replace(/^the/, '').replace(/deck$/, ''); }
  function setVariantUrl(r, dropDeck) {
    if (!window.history || !history.replaceState) return;
    var q = new URLSearchParams(location.search); q.set('variant', r.getAttribute('data-variant-id'));
    if (dropDeck) q.delete('deck');
    history.replaceState(history.state, '', location.pathname + '?' + q.toString() + location.hash);
  }
  function initChooser() {
    var radios = $$('input[name="pk-deck"]'); if (!radios.length) return;
    var dj = $('[data-pk-decks]'); DECKS = dj ? json(dj) : null;
    // ?deck=dating|go-deeper|reconnect|laughter|forever preselects that deck (e.g. the retired Play & Flirt Pakk 301s here with
    // ?deck=dating). ?variant=<id> is already honoured by Liquid (selected_or_first_available_variant). Nothing else changes.
    var want = deckNorm(new URLSearchParams(location.search).get('deck'));
    if (want) {
      var hit = radios.filter(function (r) { return deckNorm(r.value) === want || deckNorm(r.getAttribute('data-deck-name')) === want || deckNorm(r.getAttribute('data-variant-title')) === want; })[0];
      if (hit) { radios.forEach(function (r) { r.checked = r === hit; }); setVariantUrl(hit, true); }
    }
    // the chosen deck drives "What's inside" and the cart variant: apply it on load too
    var cur = radios.filter(function (r) { return r.checked; })[0];
    if (cur) applyDeck(cur.value, cur);
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        applyDeck(r.value, r);
        setVariantUrl(r, true);
      });
    });
  }

  /* ================= 4. deck pages: "Build your box" (snippets/pk-pdp-box) =================
     The 2 / 3 / 5 cards (and "Build your box", the phone bar, the compare table's "Add" buttons) open the picker: a native
     <dialog> (showModal: focus stays inside, Esc closes, focus goes back). Phones: a bottom sheet, swipe down on its top bar to
     close; desktop: a right-hand drawer (CSS). The box = picks in slot order (duplicates allowed); its size is the tab (2, 3, 5,
     or the unlisted 4 reached from a full 3). Slot 1 starts as this page's deck (or ?add=<deck>). Every figure is pre-rendered
     by Liquid per market in [data-box-json]; the cart's automatic discounts set the real price. One /cart/add.js call, then
     the cart drawer. Events: Shopify.analytics.publish('pk_…'), like pk_cart_offer_added (pk-cart.js). */
  var BOX = null;
  function track(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('pk_' + name, data || {}); } catch (e) {} }
  function bxTile(k) { return $('[data-box-deck="' + k + '"]', BOX.dlg); }
  function bxName(k) { var t = bxTile(k); return t ? t.getAttribute('data-name') : k; }
  function bxAvail(k) { var t = bxTile(k); return !!t && t.getAttribute('data-available') === 'true'; }
  function bxCount(k) { return BOX.picks.filter(function (p) { return p === k; }).length; }
  function bxFull() { return BOX.picks.length >= BOX.tier; }
  function bxTier(n) { return BOX.D.tiers[String(n)]; }
  function bxSay(t) { var l = $('[data-box-live]', BOX.dlg); if (!l) return; l.textContent = ''; setTimeout(function () { l.textContent = t; }, 60); }
  function bxToast(t) {
    var el = $('[data-box-toast]', BOX.dlg); if (!el) return;
    el.textContent = t; el.classList.add('is-on'); bxSay(t);
    clearTimeout(BOX.toastT); BOX.toastT = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }
  // the quick pick for a size, with any unavailable deck swapped for the next most popular one that's in stock;
  // 5 = one of each (this page's deck first)
  function bxQuick(n) {
    var out = [];
    if (n === 5) return [BOX.D.page].concat(BOX.D.order.filter(function (k) { return k !== BOX.D.page; })).filter(bxAvail);
    BOX.D.quick.slice(0, n).forEach(function (k) {
      if (!bxAvail(k)) k = BOX.D.order.filter(function (o) { return bxAvail(o) && out.indexOf(o) < 0 && BOX.D.quick.slice(0, n).indexOf(o) < 0; })[0];
      if (k) out.push(k);
    });
    return out;
  }
  function bxLines() {
    var by = {}, order = [];
    BOX.picks.forEach(function (k) { if (!(k in by)) { by[k] = 0; order.push(k); } by[k]++; });
    return order.map(function (k) { return { id: +bxTile(k).getAttribute('data-variant-id'), quantity: by[k] }; });
  }
  function bxRender() {
    var B = BOX, T = B.D.T, dlg = B.dlg, n = B.picks.length, cap = B.tier, full = n >= cap, tr = bxTier(cap);
    $$('[data-box-tier]', dlg).forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-box-tier') === cap ? 'true' : 'false'); });
    var four = $('[data-box-four]', dlg); four.hidden = cap !== 4; if (cap === 4) four.textContent = fillT(T.four, { tier: tr.name, save: tr.save });
    // quick pick: sizes 2 and 3
    var qb = $('[data-box-quick]', dlg), ql = cap !== 4 ? bxQuick(cap) : [];
    qb.hidden = ql.length < cap;
    if (!qb.hidden) qb.innerHTML = '<span class="pk-box__quick-t"><span aria-hidden="true">+ </span>' + esc(cap === 5 ? T.quickAll : B.D.most ? T.quickMost : T.quick) + '</span>' + (cap === 5 ? '' : ' <span class="pk-box__quick-n">' + esc(ql.map(function (k) { return bxName(k).replace(/ Deck$/, ''); }).join(' + ')) + '</span>');
    $$('[data-box-deck]', dlg).forEach(function (t) {
      var k = t.getAttribute('data-box-deck'), q = bxCount(k), add = $('[data-box-add]', t), st = $('[data-box-step]', t), nb = $('[data-box-n]', t);
      t.classList.toggle('is-on', q > 0);
      if (nb) { nb.hidden = q < 1; nb.textContent = q > 1 ? '×' + q : '✓'; }
      if (!add) return;
      add.hidden = q > 0; st.hidden = q < 1;
      $('[data-box-q]', st).textContent = q;
      $('[data-box-q]', st).setAttribute('aria-label', fillT(T.inBox, { name: bxName(k), n: q }));
      var plus = $('[data-box-step-by="1"]', st);
      if (full) { plus.setAttribute('aria-disabled', 'true'); add.setAttribute('aria-disabled', 'true'); } else { plus.removeAttribute('aria-disabled'); add.removeAttribute('aria-disabled'); }
    });
    $('[data-box-ult]', dlg).hidden = cap !== 5;
    // tray
    $('[data-box-count]', dlg).textContent = fillT(T.tray, { n: n, max: cap });
    var slots = $('[data-box-slots]', dlg), html = '';
    for (var i = 0; i < cap; i++) {
      var k = B.picks[i];
      if (k) {
        var img = $('.pk-box__img img', bxTile(k)), src = img ? (img.currentSrc || img.src) : '';
        html += '<li class="pk-box__slot is-on" style="--box:' + esc(bxTile(k).style.getPropertyValue('--box')) + '">' + (src ? '<img src="' + esc(src) + '" alt="" width="48" height="48">' : '') +
          '<button type="button" class="pk-box__slotx" data-box-slot="' + i + '" aria-label="' + esc(fillT(T.remove, { name: bxName(k) })) + '">' + B.xIcon + '</button></li>';
      } else html += '<li class="pk-box__slot"><span class="visually-hidden">' + esc(T.empty) + '</span></li>';
    }
    slots.innerHTML = html;
    var bar = $('[data-box-bar]', dlg);
    bar.setAttribute('aria-valuemax', cap); bar.setAttribute('aria-valuenow', n); bar.classList.toggle('is-full', full);
    $('span', bar).style.width = Math.min(100, Math.round(n / cap * 100)) + '%';
    // box full: point to the next size (2 → 3, 3 → 4, 4 → 5)
    var hint = $('[data-box-hint]', dlg), hb = $('[data-box-hint-btn]', dlg), ht = $('[data-box-hint-txt]', dlg), nxt = cap === 2 ? 3 : cap === 3 ? 4 : cap === 4 ? 5 : 0;
    hint.hidden = !full || (cap === 2 && !B.D.us); hb.hidden = !nxt; ht.hidden = !!nxt;   // AU 2: the shipping line below says it
    if (full && nxt) { hb.textContent = fillT(cap === 3 ? T.full4 : T.full, { tier: bxTier(nxt).name }); hb.setAttribute('data-to', nxt); }
    if (full && !nxt) ht.textContent = T.full5;
    var go = $('[data-box-go]', dlg);
    go.innerHTML = full ? esc(fillT(T.go, { n: cap, price: tr.total })) + '<span class="pk-box__go-save">' + esc(fillT(T.saving, { save: tr.save })) + '</span>' : esc(fillT(T.more, { x: cap - n }));
    go.classList.toggle('is-ready', full);
    // Australia, 2 decks: shipping is $9.90 (under $100); a 3rd deck makes it free
    var sh = $('[data-box-ship]', dlg); sh.hidden = !(full && cap === 2 && !B.D.us);
    if (!sh.hidden) { var sb = $('[data-box-ship-btn]', dlg); sb.textContent = fillT(T.ship, { flat: T.flat, diff: T.diff23 }); sb.setAttribute('data-to', 3); }
    // a smaller box the picks already fill (2 of 3 → "Switch to 2 for $99?")
    var alt = $('[data-box-alt]', dlg); alt.hidden = !(n >= 2 && n < cap && bxTier(n));
    if (!alt.hidden) { var ab = $('[data-box-alt-btn]', dlg); ab.textContent = fillT(T.alt, { tier: bxTier(n).name }); ab.setAttribute('data-to', n); }
    bxMore();
  }
  // more decks below the fold: a soft fade + "scroll" cue at the bottom of the list
  function bxMore() { var b = $('[data-box-body]', BOX.dlg); if (b) b.classList.toggle('is-more', b.scrollTop + b.clientHeight < b.scrollHeight - 12); }
  function bxSetTier(n, user) {
    var from = BOX.tier;
    if (!bxTier(n)) return;   // only real box sizes (2-5); a button without data-to must never empty the box
    if (BOX.picks.length > n) { BOX.picks = BOX.picks.slice(0, n); bxToast(fillT(BOX.D.T.toast, { n: n })); }
    BOX.tier = n; bxRender();
    if (user && from !== n) track('picker_tier_switch', { from: from, to: n });
  }
  function bxAdd(k) {
    if (!bxAvail(k)) return false;
    if (bxFull()) { var h = $('[data-box-hint]', BOX.dlg); if (h && !RM) { h.classList.remove('is-pulse'); void h.offsetWidth; h.classList.add('is-pulse'); } bxSay(h ? h.textContent : ''); return false; }
    BOX.picks.push(k); bxRender();
    bxSay(fillT(BOX.D.T.inBox, { name: bxName(k), n: bxCount(k) }) + '. ' + fillT(BOX.D.T.tray, { n: BOX.picks.length, max: BOX.tier }));
    track('picker_deck_add', { deck: k });
    return true;
  }
  function bxMinus(k) { var i = BOX.picks.lastIndexOf(k); if (i > -1) { BOX.picks.splice(i, 1); bxRender(); bxSay(fillT(BOX.D.T.inBox, { name: bxName(k), n: bxCount(k) })); } }
  function bxPrefill() {
    if (BOX.picks.length) return;
    var k = BOX.D.page; if (bxAvail(k)) BOX.picks = [k];
  }
  function bxOpen(n, opener, source) {
    if (!BOX) return;
    var o = opener && opener.getAttribute('aria-disabled') === 'true'; if (o) return;
    bxPrefill(); bxSetTier(+n || 3);
    BOX.opener = opener || null;
    if (!BOX.dlg.open) { BOX.dlg.showModal(); document.documentElement.classList.add('pk-box-open'); }
    requestAnimationFrame(bxMore);
    updateSticky();
    var tab = $('[data-box-tier][aria-pressed="true"]', BOX.dlg) || $('[data-box-close]', BOX.dlg); tab.focus();
    track('picker_open', { tier: BOX.tier, page_deck: BOX.D.page, source: source || '' });
  }
  function bxClose() { if (BOX && BOX.dlg.open) BOX.dlg.close(); }
  function initBox() {
    var dlg = $('[data-box]'); if (!dlg || typeof dlg.showModal !== 'function') return;
    var D = json($('[data-box-json]', dlg)); if (!D) return;
    var x = $('[data-box-close] svg', dlg);
    BOX = { dlg: dlg, D: D, tier: 3, picks: [], opener: null, xIcon: x ? x.outerHTML : '×' };
    var add = new URLSearchParams(location.search).get('add');   // homepage links: ?add=<deck>
    if (add && bxTile(add) && bxAvail(add)) { BOX.picks = add === D.page || !bxAvail(D.page) ? [add] : [D.page, add]; BOX.tier = Math.max(2, BOX.picks.length); }
    bxRender();
    // openers: the cards, "Build your box", the phone bar
    $$('[data-box-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = +b.getAttribute('data-box-open'), src = b.closest('[data-box-cards]') ? 'card' : b.closest('[data-sticky]') ? 'sticky' : 'cta';
        track('bundle_option_click', { tier: n, source: src });
        // a box in progress keeps its size when it's reopened from "Build your box" / the phone bar
        bxOpen(src !== 'card' && BOX.picks.length > 1 ? BOX.tier : n, b, src);
      });
    });
    // the compare table's "Add <deck>" buttons: put that deck in the box and open it
    $$('[data-builder-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-builder-add'); if (!bxTile(k)) return;
        bxPrefill();
        var need = Math.min(5, BOX.picks.length + 1);
        if (BOX.tier < need) BOX.tier = need < 2 ? 2 : need;
        bxAdd(k); bxOpen(BOX.tier, b, 'compare');
      });
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { bxClose(); return; }   // backdrop
      var t = e.target.closest('button'); if (!t || !dlg.contains(t)) return;
      if (t.matches('[data-box-close]')) bxClose();
      else if (t.matches('[data-box-tier]')) bxSetTier(+t.getAttribute('data-box-tier'), true);
      else if (t.matches('[data-box-quick]')) { BOX.picks = bxQuick(BOX.tier); bxRender(); bxSay(t.textContent + '. ' + fillT(D.T.tray, { n: BOX.picks.length, max: BOX.tier })); track('picker_quickpick', { tier: BOX.tier }); }
      else if (t.matches('[data-box-add]')) { var k = t.closest('[data-box-deck]').getAttribute('data-box-deck'); if (bxAdd(k)) { var st = $('[data-box-step-by="1"]', bxTile(k)); if (st) st.focus(); } }
      else if (t.matches('[data-box-step-by]')) { var kk = t.closest('[data-box-deck]').getAttribute('data-box-deck'); if (+t.getAttribute('data-box-step-by') > 0) bxAdd(kk); else { bxMinus(kk); if (!bxCount(kk)) $('[data-box-add]', bxTile(kk)).focus(); } }
      else if (t.matches('[data-box-slot]')) { var i = +t.getAttribute('data-box-slot'), rk = BOX.picks[i]; BOX.picks.splice(i, 1); bxRender(); bxSay(fillT(D.T.inBox, { name: bxName(rk), n: bxCount(rk) })); var nx = $('[data-box-slot]', dlg) || $('[data-box-go]', dlg); nx.focus(); }
      else if (t.matches('[data-box-hint-btn], [data-box-ship-btn], [data-box-alt-btn]')) { bxSetTier(+t.getAttribute('data-to'), true); $('[data-box-go]', dlg).focus(); }
      else if (t.matches('[data-box-go]')) bxGo(t);
    });
    var ul = $('[data-box-ult-link]', dlg); if (ul) ul.addEventListener('click', function () { track('ultimate_link_click', { page_deck: D.page }); });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('pk-box-open');
      var p = $('[data-box-panel]', dlg); p.style.transform = ''; p.classList.remove('is-dragging');
      if (BOX.opener && !BOX.handoff && document.contains(BOX.opener)) BOX.opener.focus({ preventScroll: true });
      BOX.handoff = false; updateSticky();
    });
    // phones: swipe the top bar down to close
    $('[data-box-body]', dlg).addEventListener('scroll', function () { requestAnimationFrame(bxMore); }, { passive: true });
    var drag = $('[data-box-drag]', dlg), panel = $('[data-box-panel]', dlg), y0 = null, dy = 0;
    drag.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' || e.target.closest('button')) return; y0 = e.clientY; dy = 0; panel.classList.add('is-dragging'); drag.setPointerCapture(e.pointerId); });
    drag.addEventListener('pointermove', function (e) { if (y0 === null) return; dy = Math.max(0, e.clientY - y0); panel.style.transform = 'translateY(' + dy + 'px)'; });
    function endDrag() { if (y0 === null) return; y0 = null; panel.classList.remove('is-dragging'); if (dy > 90) bxClose(); else panel.style.transform = ''; }
    drag.addEventListener('pointerup', endDrag); drag.addEventListener('pointercancel', endDrag);
    // the options row in view (once)
    var cards = $('[data-box-cards]');
    if (cards && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { track('bundle_option_view', { page_deck: D.page }); io.disconnect(); } }, { threshold: 0.5 });
      io.observe(cards);
    }
  }
  function bxGo(btn) {
    var dlg = BOX.dlg;
    if (!bxFull()) {   // not full: show the decks and nudge the Add / + buttons; nothing goes in the cart
      var grid = $('.pk-box__grid', dlg); grid.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
      if (!RM) $$('[data-box-add]:not([hidden]), [data-box-step]:not([hidden]) [data-box-step-by="1"]', dlg).forEach(function (b) { b.classList.remove('is-pulse'); void b.offsetWidth; b.classList.add('is-pulse'); });
      var first = $('[data-box-add]:not([hidden]):not([aria-disabled="true"])', dlg); if (first) first.focus({ preventScroll: true });
      return;
    }
    var tr = bxTier(BOX.tier), decks = BOX.picks.slice();
    addLines(withAddon(bxLines()), btn, {
      box: true,
      ok: function () {
        track('bundle_add_to_cart', { tier: BOX.tier, decks: decks, value: tr.t / 100, market: BOX.D.us ? 'US' : 'AU' });
        BOX.handoff = true; bxClose(); BOX.picks = []; bxRender();
        var cta = document.getElementById('pdp-cta');
        if (window.PakksCart && PakksCart.open) PakksCart.open({ trigger: cta });
      },
      fail: function (m) { bxToast(m); }
    });
  }

  /* ================= 5. add to cart ================= */
  function cartLines() { var v = $('[data-pk-variant]'); return v ? [{ id: +v.value, quantity: 1 }] : []; }
  // tick-box add-on: one extra line in the same /cart/add.js call (unticked by default)
  function withAddon(lines) {
    var t = $('[data-pk-addon-tick]'), row = t && t.closest('[data-pk-addon-row]');
    if (t && t.checked && row && !row.hidden && lines.length) lines.push({ id: +t.value, quantity: 1 });
    return lines;
  }
  function syncAddon() {
    var row = $('[data-pk-addon-row]'); if (!row) return;
    var d = window.PakksCart && window.PakksCart.data, h = ',' + row.getAttribute('data-handle') + ',';
    var inCart = !!(d && d.covered && d.covered.indexOf(h) > -1);
    row.hidden = inCart;
    if (inCart) { var t = $('[data-pk-addon-tick]', row); if (t) t.checked = false; }
  }
  function cartUrl(path) { var base = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url.replace(/cart\/add$/, '') : (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return base + path; }
  var busy = false;
  // o.box: the picker's add (the drawer opens after the sheet closes, errors show in the sheet); o.ok / o.fail callbacks
  function addLines(lines, trigger, o) {
    o = o || {};
    if (busy || !lines.length) return;
    busy = true;
    var marks = $$('[data-add-to-cart]').concat(trigger ? [trigger] : []);
    marks.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    var done = function () { busy = false; marks.forEach(function (b) { b.removeAttribute('aria-busy'); }); };
    var msgs = root ? root.getAttribute('data-msgs') : null, M = msgs ? JSON.parse(msgs) : {};
    var p;
    if (window.PakksCart && typeof window.PakksCart.add === 'function') {
      p = Promise.resolve(window.PakksCart.add(lines, { open: !o.box, quiet: !!o.box, trigger: trigger }));
    } else {
      p = fetch(cartUrl('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j && (j.description || j.message) || 'error'); return j; }); })
        .then(function () { return fetch(cartUrl('cart.js'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var detail = { item_count: cart.item_count, cart: cart, lines: lines };
          document.dispatchEvent(new CustomEvent('pk:cart:updated', { detail: detail }));
          document.dispatchEvent(new CustomEvent('pk:cart-updated', { detail: detail }));
          if (!o.box) { var tg = $('[data-pk-cart-toggle]'); if (tg) tg.click(); }
        });
    }
    p.then(function () { done(); if (o.ok) o.ok(); if (!o.box) say(M.added || 'Added to your cart.'); })
      .catch(function (e) {
        done();
        var m = (M.error || 'Sorry, that didn’t work. Please try again.') + (e && e.message && e.message !== 'error' ? ' ' + e.message : '');
        if (o.fail) o.fail(m); else say(m);
      });
  }
  function addToCart(trigger) {
    var cta = document.getElementById('pdp-cta');
    if (!BOX && cta && cta.getAttribute('aria-disabled') === 'true') return;
    addLines(withAddon(cartLines()), trigger, { ok: function () { if (BOX) track('single_deck_add_to_cart', { deck: BOX.D.page }); } });
  }
  function initAdd() {
    syncAddon();   // shows the tick-box row (it needs JS), unless the add-on is already in the cart
    document.addEventListener('pk:cart:updated', function () { setTimeout(syncAddon, 0); });
    var f = $('[data-pk-form]');
    if (f) f.addEventListener('submit', function (e) { e.preventDefault(); addToCart(e.submitter || $('[data-box-single]') || $('#pdp-cta')); });
    $$('[data-sticky-btn]').forEach(function (b) { b.addEventListener('click', function () { addToCart(b); }); });
    // deck pages: the matched Pakk
    $$('[data-box-upsell-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sec = b.closest('[data-box-upsell]');
        track('pakk_upsell_click', { pakk: sec ? sec.getAttribute('data-pakk') : '', page_deck: BOX ? BOX.D.page : '' });
        addLines([{ id: +b.getAttribute('data-box-upsell-add'), quantity: 1 }], b);
      });
    });
  }

  /* ================= 6. sticky bar ================= */
  var sticky = $('[data-sticky]');
  function onScreen(el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight && r.height > 0; }
  function updateSticky() {
    var cta = document.getElementById('pdp-cta'); if (!cta || !sticky) return;
    var past = cta.getBoundingClientRect().bottom < 0;
    var other = $$('footer, [data-footer], .pdp-footer').some(onScreen);
    var dlg = document.querySelector('dialog[open]');
    var show = past && !other && !dlg;
    if (show !== sticky.classList.contains('is-shown')) { sticky.classList.toggle('is-shown', show); sticky.inert = !show; }
  }
  function initSticky() {
    if (!sticky) return;
    var ticking = false;
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; updateSticky(); }); } }, { passive: true });
    addEventListener('resize', updateSticky, { passive: true });
    updateSticky();
  }

  /* ================= 7. customer videos ================= */
  function pauseAll(except) { $$('video').forEach(function (v) { if (v !== except && !v.paused) v.pause(); }); }
  function initVideos() {
    $$('[data-video-open]').forEach(function (btn) {
      var dlg = document.getElementById(btn.getAttribute('data-video-open')); if (!dlg || typeof dlg.showModal !== 'function' || btn.__init) return; btn.__init = true;
      btn.addEventListener('click', function () { pauseAll(); dlg.__opener = btn; dlg.showModal(); updateSticky(); var c = $('[data-video-close]', dlg); if (c) c.focus(); });
    });
    $$('[data-video-dialog]').forEach(function (dlg) {
      if (dlg.__init) return; dlg.__init = true;
      var v = $('video', dlg);
      if (v) v.addEventListener('play', function () { pauseAll(v); });
      $$('[data-video-close]', dlg).forEach(function (c) { c.addEventListener('click', function () { dlg.close(); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });   // backdrop
      dlg.addEventListener('close', function () { if (v) v.pause(); if (dlg.__opener) dlg.__opener.focus(); updateSticky(); });
    });
  }

  /* ================= 8. third-party review widget (cross-origin iframe): focus ring while keyboard focus is inside it ================= */
  function initFrameFocus() {
    addEventListener('blur', function () { setTimeout(function () { var a = document.activeElement; if (a && a.tagName === 'IFRAME' && a.closest('.pdp-loox, .pk-vid__app')) a.classList.add('pk-iframe-focus'); }, 0); });
    addEventListener('focus', function () { $$('.pk-iframe-focus').forEach(function (x) { x.classList.remove('pk-iframe-focus'); }); });
    document.addEventListener('focusin', function () { $$('.pk-iframe-focus').forEach(function (x) { x.classList.remove('pk-iframe-focus'); }); });
  }

  /* ================= 9. land at the top (Kayci 24 Oct, iPhone) =================
     On a fresh navigation without a #anchor the page must open at the top. Third-party widgets that load below (Loox reviews
     iframe, Videowise) can take focus while they load; iOS Safari then scrolls the page to them (Chrome ignores focus calls from
     cross-origin iframes without a user gesture). Until the shopper first touches, scrolls or types (max 6 s), any scroll
     away from the top is undone. Back/forward and reload keep the browser's own restored position. */
  function keepTop() {
    if (location.hash) return;
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type && nav.type !== 'navigate') return;
    var done = false, until = Date.now() + 6000;
    var stop = function () { done = true; };
    ['touchstart', 'pointerdown', 'click', 'wheel', 'keydown', 'hashchange'].forEach(function (t) { addEventListener(t, stop, { passive: true, capture: true, once: true }); });
    addEventListener('scroll', function onS() {
      if (done || Date.now() > until) { removeEventListener('scroll', onS); return; }
      if (window.scrollY > 0) {
        var a = document.activeElement; if (a && a.tagName === 'IFRAME' && a.blur) a.blur();
        window.scrollTo(0, 0);
      }
    }, { passive: true });
  }

  /* ================= boot ================= */
  keepTop();
  initGallery(); initSamples(document); initRow(document); initCarousel(document); initDisclosure(document); initJump(document);
  initChooser(); initBox(); initAdd(); initSticky(); initVideos(); initFrameFocus();
  if (PK.market === 'us') initArrives();
  /* theme editor: re-init a section after it re-renders */
  document.addEventListener('shopify:section:load', function (e) { initSamples(e.target); initRow(e.target); initCarousel(e.target); initDisclosure(e.target); initJump(e.target); initVideos(); });
})();
